<template>
  <b-card 
    no-body
  >
    <b-card-header>
      <b-card-title>{{ user.naam }}</b-card-title>
      <b-card-sub-title /> 
    </b-card-header>
    <b-card-body>
      <b-button-group class="w-100">
        <b-button 
          v-for="n in 4"
          :key="n"
          :pressed="n === kwartaal"
          size="lg" 
          variant="dark"
          @click="() => kwartaal = n"
        >
          Q{{ n }}
          <b-progress
            :value="user[`Q${n}`].OPEN+user[`Q${n}`].AUDIT+user[`Q${n}`].CLOSED"
            :max="144" 
            show-value
          />
        </b-button>
      </b-button-group>
    </b-card-body>
    <b-card-body body-bg-variant="dark">
      <b-row>
        <b-col 
          v-for="n in ['OPEN','GEPLAND','AUDIT','CLOSED']"
          :key="n" 
          class="text-center"
        >
          {{ n }}
          <div class="display-4">
            {{ user[`Q${kwartaal}`][n] != null ? user[`Q${kwartaal}`][n] : 0 }}
          </div>
          <b-button @click="$emit('toon-details',{ id: user.id,kwartaal: kwartaal,status:n})">
            Toon details
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>
<script>
import moment from "moment";
export default {
    name: 'OperationeelStatus',
    components: {},
    mixins: [],
    props: {
      user: {
        type: Object,
        default: null
      }
    },
    data() {
        return  {
          kwartaal: moment().quarter()
        }
    },
    computed: {},
    watch: {},
    mounted () {
        
    },
    methods: {},
          
}
</script>